(function () {
  'use strict';

  if (window.RYASmartIntake) return;

  var ROOT_SELECTOR = '[data-rya-smart-intake]';
  var VEHICLE_KEY = 'rya:smart-intake:vehicle:v1';
  var DEFAULT_WA = '50433899071';

  var WMI_MAKE = {
    JT: 'Toyota',
    MR: 'Toyota',
    '2T': 'Toyota',
    '4T': 'Toyota',
    '5T': 'Toyota',
    JH: 'Honda',
    '1H': 'Honda',
    '2H': 'Honda',
    '19': 'Honda',
    '5F': 'Honda',
    JN: 'Nissan',
    '1N': 'Nissan',
    '3N': 'Nissan',
    KM: 'Hyundai',
    KN: 'Kia',
    JA: 'Mitsubishi',
    MM: 'Mitsubishi',
    JM: 'Mazda',
    '3M': 'Mazda',
    '4F': 'Mazda',
    '1F': 'Ford',
    '3F': 'Ford',
    '1G': 'Chevrolet',
    '2G': 'Chevrolet',
    '3G': 'Chevrolet',
    KL: 'Chevrolet',
    JS: 'Suzuki',
    WV: 'Volkswagen',
    '3V': 'Volkswagen',
    WB: 'BMW',
    WD: 'Mercedes-Benz'
  };

  var VIN_ORIGIN = {
    J: 'Japón',
    K: 'Corea',
    L: 'China',
    M: 'India/Tailandia',
    S: 'Reino Unido',
    V: 'Europa',
    W: 'Alemania',
    Z: 'Italia',
    '1': 'EE. UU.',
    '4': 'EE. UU.',
    '5': 'EE. UU.',
    '2': 'Canadá',
    '3': 'México',
    '8': 'Sudamérica',
    '9': 'Brasil'
  };

  var VIN_YEAR = {
    A: 2010,
    B: 2011,
    C: 2012,
    D: 2013,
    E: 2014,
    F: 2015,
    G: 2016,
    H: 2017,
    J: 2018,
    K: 2019,
    L: 2020,
    M: 2021,
    N: 2022,
    P: 2023,
    R: 2024,
    S: 2025,
    T: 2026,
    V: 1997,
    W: 1998,
    X: 1999,
    Y: 2000,
    '1': 2001,
    '2': 2002,
    '3': 2003,
    '4': 2004,
    '5': 2005,
    '6': 2006,
    '7': 2007,
    '8': 2008,
    '9': 2009
  };

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function cleanText(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function vinClean(value) {
    return String(value || '')
      .toUpperCase()
      .replace(/[^A-Z0-9]/g, '')
      .replace(/I/g, '1')
      .replace(/O/g, '0')
      .replace(/Q/g, '0')
      .slice(0, 17);
  }

  function vinCharOk(vin) {
    return /^[A-HJ-NPR-Z0-9]{17}$/.test(vin);
  }

  function vinTranslit(char) {
    var map = { A: 1, B: 2, C: 3, D: 4, E: 5, F: 6, G: 7, H: 8, J: 1, K: 2, L: 3, M: 4, N: 5, P: 7, R: 9, S: 2, T: 3, U: 4, V: 5, W: 6, X: 7, Y: 8, Z: 9 };
    return /[0-9]/.test(char) ? parseInt(char, 10) : map[char] || 0;
  }

  function vinCheckDigit(vin) {
    var weights = [8, 7, 6, 5, 4, 3, 2, 10, 0, 9, 8, 7, 6, 5, 4, 3, 2];
    var sum = 0;
    for (var i = 0; i < 17; i += 1) sum += vinTranslit(vin[i]) * weights[i];
    var result = sum % 11;
    return result === 10 ? 'X' : String(result);
  }

  function vinValid(vin) {
    return vinCharOk(vin) && vin[8] === vinCheckDigit(vin);
  }

  function vinAutoCorrect(vin) {
    if (vinValid(vin)) return vin;

    var pairs = {
      '5': 'S',
      S: '5',
      '8': 'B',
      B: '8',
      '2': 'Z',
      Z: '2',
      '6': 'G',
      G: '6',
      '0': 'D',
      D: '0',
      '4': 'A',
      A: '4'
    };

    for (var i = 0; i < 17; i += 1) {
      var alt = pairs[vin[i]];
      if (!alt) continue;
      var candidate = vin.slice(0, i) + alt + vin.slice(i + 1);
      if (vinValid(candidate)) return candidate;
    }

    return vin;
  }

  function decodeVinLocal(vin) {
    var year = VIN_YEAR[vin[9]] || '';
    var make = WMI_MAKE[vin.slice(0, 2)] || WMI_MAKE[vin.slice(0, 3)] || '';
    return {
      vin: vin,
      make: make,
      model: '',
      year: year,
      detail: [VIN_ORIGIN[vin[0]] ? 'Origen ' + VIN_ORIGIN[vin[0]] : '', vinValid(vin) ? 'VIN verificado' : 'VIN con formato válido'].filter(Boolean).join(' · ')
    };
  }

  function titleCase(value) {
    return String(value || '').toLowerCase().replace(/\b[a-záéíóúñü]/g, function (letter) {
      return letter.toUpperCase();
    });
  }

  function decodeVinRemote(vin) {
    var local = decodeVinLocal(vin);
    var controller = window.AbortController ? new AbortController() : null;
    var timeout = controller ? setTimeout(function () { controller.abort(); }, 6500) : null;
    var url = 'https://vpic.nhtsa.dot.gov/api/vehicles/DecodeVinValues/' + encodeURIComponent(vin) + '?format=json';

    return fetch(url, { signal: controller ? controller.signal : undefined })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (data) {
        if (timeout) clearTimeout(timeout);
        var row = data && data.Results && data.Results[0] ? data.Results[0] : null;
        if (!row) return local;

        var detail = [];
        if (row.DisplacementL) detail.push('Motor ' + parseFloat(row.DisplacementL).toFixed(1) + ' L');
        if (row.EngineCylinders) detail.push(row.EngineCylinders + ' cil');
        if (row.DriveType) detail.push(row.DriveType.replace(/\//g, ' / '));
        if (row.BodyClass) detail.push(row.BodyClass.split('(')[0].trim());
        if (local.detail) detail.push(local.detail);

        return {
          vin: vin,
          make: titleCase(row.Make || local.make),
          model: titleCase(row.Model || local.model),
          year: row.ModelYear || local.year,
          detail: detail.filter(Boolean).join(' · ')
        };
      })
      .catch(function () {
        if (timeout) clearTimeout(timeout);
        return local;
      });
  }

  function vehicleLabel(vehicle) {
    if (!vehicle) return '';
    return [vehicle.make, vehicle.model, vehicle.year].filter(Boolean).join(' ').replace(/\s+/g, ' ').trim();
  }

  function getStoredVehicle() {
    try {
      if (window.RYAuto && window.RYAuto.vehicles && typeof window.RYAuto.vehicles.active === 'function') {
        var active = window.RYAuto.vehicles.active();
        if (active) {
          return {
            make: active.make || '',
            model: active.model || '',
            year: active.year || '',
            engine: active.engine || '',
            vin: active.vin || ''
          };
        }
      }
    } catch (error) {
      // Use local fallback below.
    }

    try {
      var raw = localStorage.getItem(VEHICLE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (error) {
      return null;
    }
  }

  function saveVehicle(vehicle) {
    var clean = {
      make: cleanText(vehicle.make),
      model: cleanText(vehicle.model),
      year: cleanText(vehicle.year),
      engine: cleanText(vehicle.engine),
      vin: cleanText(vehicle.vin)
    };

    try {
      localStorage.setItem(VEHICLE_KEY, JSON.stringify(clean));
    } catch (error) {
      // Search still works without storage.
    }

    try {
      if (window.RYAuto && window.RYAuto.ready && window.RYAuto.vehicles) {
        window.RYAuto.ready(function (R) {
          var list = R.vehicles.list ? R.vehicles.list() : [];
          var label = vehicleLabel(clean);
          var existing = list.filter(function (item) {
            return vehicleLabel(item).toLowerCase() === label.toLowerCase();
          })[0];

          if (existing && R.vehicles.setActive) {
            R.vehicles.setActive(existing.id);
          } else if (R.vehicles.create) {
            R.vehicles.create({
              nickname: label || 'Mi carro',
              make: clean.make,
              model: clean.model,
              year: clean.year,
              engine: clean.engine,
              vin: clean.vin
            });
          }
        });
      }
    } catch (error) {
      // Local storage is the source for this component if Mi Carro is unavailable.
    }

    updateAllVehicleChips();
    return clean;
  }

  function findSearchInput(root) {
    var box = root.closest('.search-modal__content, .ry-search-box, .rya-hero__content, .template-search__search, main');
    if (box) {
      var localInput = box.querySelector('form[action*="/search"] input[name="q"], form[role="search"] input[name="q"]');
      if (localInput) return localInput;
    }
    return document.querySelector('form[action*="/search"] input[name="q"], form[role="search"] input[name="q"]');
  }

  function setSearchInput(root, value) {
    var input = findSearchInput(root);
    if (!input) return null;
    input.value = cleanText(value);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    return input;
  }

  function appendVehicleContext(query) {
    var vehicle = getStoredVehicle();
    var label = vehicleLabel(vehicle);
    var base = cleanText(query);
    if (!label) return base;
    if (!base) return label;

    var lower = base.toLowerCase();
    var parts = [vehicle.make, vehicle.model, vehicle.year].filter(Boolean);
    var missing = parts.filter(function (part) { return lower.indexOf(String(part).toLowerCase()) === -1; });
    return cleanText([base].concat(missing).join(' '));
  }

  function buildQuery(query) {
    var withVehicle = appendVehicleContext(query);
    if (window.RYASmartSearch && typeof window.RYASmartSearch.buildShopifyQuery === 'function') {
      return window.RYASmartSearch.buildShopifyQuery(withVehicle) || withVehicle;
    }
    return withVehicle;
  }

  function submitSearch(root, query) {
    var finalQuery = buildQuery(query || (findSearchInput(root) && findSearchInput(root).value) || '');
    if (!finalQuery) return;

    var input = setSearchInput(root, finalQuery);
    var form = input && input.closest('form');
    if (form) {
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.submit();
      return;
    }

    var searchUrl = root.getAttribute('data-search-url') || '/search';
    window.location.href = searchUrl + '?type=product&q=' + encodeURIComponent(finalQuery);
  }

  function setStatus(root, selector, message, kind) {
    var target = root.querySelector(selector);
    if (!target) return;
    target.classList.remove('is-ok', 'is-warn', 'is-stop');
    if (kind) target.classList.add('is-' + kind);
    target.textContent = message || '';
  }

  function updateVehicleChip(root) {
    var chip = root.querySelector('[data-rya-vehicle-chip]');
    var searchVehicle = root.querySelector('[data-rya-search-vehicle]');
    if (!chip) return;

    var vehicle = getStoredVehicle();
    var label = vehicleLabel(vehicle);
    if (!label) {
      chip.hidden = true;
      chip.textContent = '';
      if (searchVehicle) searchVehicle.hidden = true;
      return;
    }

    chip.hidden = false;
    chip.textContent = label;
    if (searchVehicle) searchVehicle.hidden = false;
  }

  function updateAllVehicleChips() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(updateVehicleChip);
  }

  function setMode(root, mode) {
    root.querySelectorAll('[data-rya-mode-button]').forEach(function (button) {
      var active = button.getAttribute('data-rya-mode-button') === mode;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    root.querySelectorAll('[data-rya-panel]').forEach(function (panel) {
      panel.classList.toggle('is-active', panel.getAttribute('data-rya-panel') === mode);
    });

    root.setAttribute('data-current-mode', mode);
  }

  function findVinInText(value) {
    var cleaned = vinClean(value);
    var match = cleaned.match(/[A-HJ-NPR-Z0-9]{17}/);
    return match ? match[0] : '';
  }

  function findCodeInText(value) {
    var match = String(value || '').toUpperCase().match(/[A-Z0-9][A-Z0-9-]{4,}[A-Z0-9]/);
    return match ? match[0] : '';
  }

  function decodeVinForRoot(root, vin) {
    var input = root.querySelector('[data-rya-vin-input]');
    var cleanVin = vinAutoCorrect(vinClean(vin || (input && input.value) || ''));
    if (input) input.value = cleanVin;

    if (cleanVin.length !== 17 || !vinCharOk(cleanVin)) {
      setStatus(root, '[data-rya-vin-status]', 'El VIN debe tener 17 caracteres válidos. No usa I, O ni Q.', 'stop');
      return Promise.resolve(null);
    }

    var checksumOk = vinValid(cleanVin);
    setStatus(root, '[data-rya-vin-status]', checksumOk ? 'VIN válido. Identificando vehículo...' : 'Formato válido. Revisando identificación...', checksumOk ? 'ok' : 'warn');

    return decodeVinRemote(cleanVin).then(function (vehicle) {
      if (!vehicle.make && !vehicle.model && !vehicle.year) {
        setStatus(root, '[data-rya-vin-status]', 'No se pudo identificar el vehículo. Escribinos y lo revisamos con la foto.', 'stop');
        return null;
      }

      var saved = saveVehicle(vehicle);
      var label = vehicleLabel(saved);
      setSearchInput(root, label);
      setStatus(root, '[data-rya-vin-status]', 'Carro guardado: ' + label + '. Ahora podés buscar frenos, filtros, suspensión, motor o cualquier pieza con ese contexto.', 'ok');
      return saved;
    });
  }

  function imageFromFile(file) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      var url = URL.createObjectURL(file);
      img.onload = function () {
        resolve({ img: img, url: url });
      };
      img.onerror = function () {
        URL.revokeObjectURL(url);
        reject(new Error('image-load'));
      };
      img.src = url;
    });
  }

  function scanBarcode(file) {
    if (!('BarcodeDetector' in window)) return Promise.resolve('');

    return imageFromFile(file)
      .then(function (loaded) {
        var detector = new window.BarcodeDetector({
          formats: ['code_39', 'code_128', 'ean_13', 'ean_8', 'itf', 'qr_code', 'data_matrix', 'pdf417']
        });
        return detector.detect(loaded.img).then(function (codes) {
          URL.revokeObjectURL(loaded.url);
          return codes && codes[0] && codes[0].rawValue ? codes[0].rawValue : '';
        }).catch(function () {
          URL.revokeObjectURL(loaded.url);
          return '';
        });
      })
      .catch(function () { return ''; });
  }

  function setPhotoPreview(root, file, note, code) {
    var preview = root.querySelector('[data-rya-photo-preview]');
    var image = root.querySelector('[data-rya-photo-image]');
    var title = root.querySelector('[data-rya-photo-title]');
    var text = root.querySelector('[data-rya-photo-note]');
    if (!preview || !image) return;

    if (root._ryaPhotoUrl) URL.revokeObjectURL(root._ryaPhotoUrl);
    root._ryaPhotoUrl = URL.createObjectURL(file);
    root._ryaPhotoFile = file;
    root._ryaPhotoCode = code || '';

    image.src = root._ryaPhotoUrl;
    preview.hidden = false;
    if (title) title.textContent = code ? 'Código detectado' : 'Foto lista';
    if (text) text.textContent = note || 'Agregá un detalle y buscá, o enviá la foto por WhatsApp.';
  }

  function handlePartPhoto(root, file) {
    if (!file) return;
    root._ryaPhotoPurpose = 'part';
    setPhotoPreview(root, file, 'Revisando si hay código visible...', '');

    scanBarcode(file).then(function (raw) {
      var vin = findVinInText(raw);
      var code = findCodeInText(raw);

      if (vin) {
        setPhotoPreview(root, file, 'Encontramos un VIN en la imagen. Se puede guardar el carro antes de buscar.', vin);
        var vinInput = root.querySelector('[data-rya-vin-input]');
        if (vinInput) vinInput.value = vin;
        decodeVinForRoot(root, vin);
        return;
      }

      if (code) {
        setPhotoPreview(root, file, 'Usaremos este código en la búsqueda: ' + code, code);
        setSearchInput(root, code);
        return;
      }

      setPhotoPreview(root, file, 'Foto lista. Agregá el tipo de pieza o enviala por WhatsApp para confirmarla.', '');
    });
  }

  function handleVinPhoto(root, file) {
    if (!file) return;
    root._ryaPhotoFile = file;
    root._ryaPhotoPurpose = 'vin';
    setStatus(root, '[data-rya-vin-status]', 'Leyendo código en la imagen...', 'warn');

    scanBarcode(file).then(function (raw) {
      var vin = findVinInText(raw);
      var code = findCodeInText(raw);

      if (vin) {
        decodeVinForRoot(root, vin);
        return;
      }

      if (code) {
        setSearchInput(root, code);
        setStatus(root, '[data-rya-vin-status]', 'Encontramos un código: ' + code + '. Lo pasamos a la búsqueda.', 'ok');
        return;
      }

      setStatus(root, '[data-rya-vin-status]', 'No se leyó automáticamente en este navegador. Podés escribir el VIN o enviar la foto por WhatsApp.', 'warn');
    });
  }

  function selectedFamily(root) {
    var selected = root.querySelector('[data-rya-family].is-selected');
    return selected ? selected.getAttribute('data-rya-family') || '' : '';
  }

  function selectedPosition(root) {
    var selected = root.querySelector('[data-rya-position].is-selected');
    return selected ? selected.getAttribute('data-rya-position') || '' : '';
  }

  function buildPhotoQuery(root) {
    var family = selectedFamily(root);
    var position = selectedPosition(root);
    var details = root.querySelector('[data-rya-photo-details]');
    var code = root._ryaPhotoCode || '';
    return cleanText([code, family, position, details ? details.value : ''].filter(Boolean).join(' '));
  }

  function whatsappUrl(root, text) {
    var number = root.getAttribute('data-whatsapp-number') || DEFAULT_WA;
    number = number.replace(/\D/g, '') || DEFAULT_WA;
    return 'https://wa.me/' + number + '?text=' + encodeURIComponent(text);
  }

  function buildWhatsAppText(root) {
    var vehicle = getStoredVehicle();
    var details = buildPhotoQuery(root) || (findSearchInput(root) && findSearchInput(root).value) || '';
    var purpose = root._ryaPhotoPurpose === 'vin' ? 'vin' : 'part';
    var lines = [
      purpose === 'vin'
        ? 'Hola RepuestosYA, necesito que me ayuden a leer o confirmar el VIN de esta revisión/padrón.'
        : 'Hola RepuestosYA, necesito ayuda para encontrar este repuesto.',
      vehicleLabel(vehicle) ? 'Carro: ' + vehicleLabel(vehicle) : '',
      vehicle && vehicle.vin ? 'VIN: ' + vehicle.vin : '',
      details ? 'Datos de búsqueda: ' + details : '',
      root._ryaPhotoFile ? (purpose === 'vin' ? 'Adjunto la foto del documento o placa VIN.' : 'Adjunto la foto de la pieza.') : '',
      'Me confirman compatibilidad y disponibilidad, por favor.'
    ];
    return lines.filter(Boolean).join('\n');
  }

  function sendWhatsApp(root) {
    var text = buildWhatsAppText(root);
    var file = root._ryaPhotoFile;

    if (file && navigator.canShare && navigator.share) {
      try {
        if (navigator.canShare({ files: [file] })) {
          navigator.share({ files: [file], text: text, title: 'RepuestosYA' }).catch(function () {
            window.open(whatsappUrl(root, text), '_blank', 'noopener');
          });
          return;
        }
      } catch (error) {
        // Fall back to link.
      }
    }

    window.open(whatsappUrl(root, text), '_blank', 'noopener');
  }

  function bindRoot(root) {
    if (root.dataset.ryaSmartReady === 'true') {
      updateVehicleChip(root);
      return;
    }
    root.dataset.ryaSmartReady = 'true';
    root.setAttribute('data-current-mode', 'text');

    root.querySelectorAll('[data-rya-mode-button]').forEach(function (button) {
      button.addEventListener('click', function () {
        setMode(root, button.getAttribute('data-rya-mode-button'));
      });
    });

    root.querySelectorAll('[data-rya-chip]').forEach(function (button) {
      button.addEventListener('click', function () {
        var value = button.getAttribute('data-rya-chip') || '';
        setSearchInput(root, value);
        submitSearch(root, value);
      });
    });

    root.querySelectorAll('[data-rya-family]').forEach(function (button) {
      button.addEventListener('click', function () {
        root.querySelectorAll('[data-rya-family]').forEach(function (item) { item.classList.remove('is-selected'); });
        button.classList.add('is-selected');
      });
    });

    root.querySelectorAll('[data-rya-position]').forEach(function (button) {
      button.addEventListener('click', function () {
        root.querySelectorAll('[data-rya-position]').forEach(function (item) { item.classList.remove('is-selected'); });
        button.classList.add('is-selected');
      });
    });

    var vinInput = root.querySelector('[data-rya-vin-input]');
    if (vinInput) {
      vinInput.addEventListener('input', function () {
        var cleaned = vinClean(vinInput.value);
        vinInput.value = cleaned;
        if (!cleaned) setStatus(root, '[data-rya-vin-status]', '', '');
        else if (cleaned.length < 17) setStatus(root, '[data-rya-vin-status]', cleaned.length + ' / 17 caracteres', 'warn');
        else if (vinValid(cleaned)) setStatus(root, '[data-rya-vin-status]', 'VIN válido. Listo para identificar.', 'ok');
        else if (vinCharOk(cleaned)) setStatus(root, '[data-rya-vin-status]', 'Formato correcto. Se puede revisar identificación.', 'warn');
        else setStatus(root, '[data-rya-vin-status]', 'Revisá los caracteres del VIN.', 'stop');
      });
    }

    var decodeButton = root.querySelector('[data-rya-vin-decode]');
    if (decodeButton) decodeButton.addEventListener('click', function () { decodeVinForRoot(root); });

    var vehicleSearch = root.querySelector('[data-rya-search-vehicle]');
    if (vehicleSearch) {
      vehicleSearch.addEventListener('click', function () {
        var vehicle = getStoredVehicle();
        submitSearch(root, vehicleLabel(vehicle));
      });
    }

    var vinFile = root.querySelector('[data-rya-vin-file]');
    var pickVinPhoto = root.querySelector('[data-rya-pick-vin-photo]');
    var vinWhatsapp = root.querySelector('[data-rya-vin-whatsapp]');
    if (pickVinPhoto && vinFile) {
      pickVinPhoto.addEventListener('click', function () { vinFile.click(); });
      vinFile.addEventListener('change', function () {
        var file = vinFile.files && vinFile.files[0];
        vinFile.value = '';
        handleVinPhoto(root, file);
      });
    }
    if (vinWhatsapp) vinWhatsapp.addEventListener('click', function () {
      root._ryaPhotoPurpose = 'vin';
      sendWhatsApp(root);
    });

    var cameraFile = root.querySelector('[data-rya-camera-file]');
    var galleryFile = root.querySelector('[data-rya-gallery-file]');
    var pickCamera = root.querySelector('[data-rya-pick-camera]');
    var pickGallery = root.querySelector('[data-rya-pick-gallery]');

    if (pickCamera && cameraFile) {
      pickCamera.addEventListener('click', function () { cameraFile.click(); });
      cameraFile.addEventListener('change', function () {
        var file = cameraFile.files && cameraFile.files[0];
        cameraFile.value = '';
        handlePartPhoto(root, file);
      });
    }

    if (pickGallery && galleryFile) {
      pickGallery.addEventListener('click', function () { galleryFile.click(); });
      galleryFile.addEventListener('change', function () {
        var file = galleryFile.files && galleryFile.files[0];
        galleryFile.value = '';
        handlePartPhoto(root, file);
      });
    }

    var photoSearch = root.querySelector('[data-rya-photo-search]');
    if (photoSearch) {
      photoSearch.addEventListener('click', function () {
        var query = buildPhotoQuery(root);
        if (!query) {
          var details = root.querySelector('[data-rya-photo-details]');
          if (details) details.focus();
          return;
        }
        submitSearch(root, query);
      });
    }

    var photoWhatsapp = root.querySelector('[data-rya-photo-whatsapp]');
    if (photoWhatsapp) photoWhatsapp.addEventListener('click', function () { sendWhatsApp(root); });

    updateVehicleChip(root);
  }

  function init() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(bindRoot);
  }

  window.RYASmartIntake = {
    init: init,
    getVehicle: getStoredVehicle,
    saveVehicle: saveVehicle,
    decodeVin: decodeVinRemote,
    buildQuery: buildQuery
  };

  ready(init);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:select', init);
  window.addEventListener('storage', function (event) {
    if (event.key === VEHICLE_KEY) updateAllVehicleChips();
  });
})();
